// Hummin — footer reveal-on-scroll (Revivr pattern).
// Adds .footer-scroll-effect to <body> so main scrolls above sticky footer.
// Desktop (>=1200px): always-on if main height >= 150% viewport.
// Mobile (<1200px): toggles based on scroll position near footer.

(() => {
  const FOOTER_SCROLL_CLASS = 'footer-scroll-effect';
  const MIN_RATIO = 1.5;

  const init = () => {
    const main = document.querySelector('.site-main');
    const footer = document.querySelector('.shopify-section-group-footer-group');
    if (!main || !footer) return;

    const hasRequiredHeight = () => main.offsetHeight >= window.innerHeight * MIN_RATIO;

    const updateMobile = () => {
      const footerHeight = footer.offsetHeight;
      const scrollBottomPos = window.innerHeight + window.scrollY;
      const footerShowPos = document.documentElement.scrollHeight - footerHeight;
      const atBottom = scrollBottomPos >= document.documentElement.scrollHeight - 1;

      if (scrollBottomPos >= footerShowPos && hasRequiredHeight()) {
        document.body.classList.add(FOOTER_SCROLL_CLASS);
      } else {
        document.body.classList.remove(FOOTER_SCROLL_CLASS);
      }
      // Improve mobile UX: drop class when user fully reaches end (so footer accordion expansion isn't blocked)
      if (atBottom) document.body.classList.remove(FOOTER_SCROLL_CLASS);
    };

    const updateDesktop = () => {
      if (hasRequiredHeight()) {
        document.body.classList.add(FOOTER_SCROLL_CLASS);
      } else {
        document.body.classList.remove(FOOTER_SCROLL_CLASS);
      }
    };

    const isMobile = () => window.innerWidth < 1200;

    const apply = () => {
      if (isMobile()) updateMobile();
      else updateDesktop();
    };

    apply();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
